import React, { forwardRef, useState } from 'react'
import Icon, { IconName, IconColor } from 'particles/Icon'
import Text from 'particles/Text'
import { StyledTextTag, getTagFontColor } from './style'
import { useTheme } from '../themes/styled'
import Tooltip from 'particles/Tooltip'

export type TagState = 'default' | 'hover' | 'disable'
export type TagContentType = 'neutral' | 'positive' | 'warning' | 'negative'

export interface TextTagProps {
    label: string
    contentType?: TagContentType
    number?: number
    icon?: IconName
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
    maxWidth?: string
}

const TextTag = forwardRef<HTMLButtonElement, TextTagProps>(
    ({ contentType = 'neutral', label, number, icon, onClick, maxWidth = '224px', ...props }, ref) => {
        const [tooltipLabel, setTooltipLabel] = useState<string>()

        const onTagHover = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (e.currentTarget.innerHTML !== tooltipLabel) {
                if (e.currentTarget.scrollWidth > e.currentTarget.offsetWidth) {
                    setTooltipLabel(label)
                } else {
                    if (tooltipLabel) {
                        setTooltipLabel(undefined)
                    }
                }
            }
        }
        const theme = useTheme()
        return (
            <Tooltip label={tooltipLabel} placement="bottom">
                <StyledTextTag
                    ref={ref}
                    onClick={onClick}
                    contentType={contentType}
                    label={label}
                    maxWidth={maxWidth}
                    {...props}
                >
                    {number && (
                        <Text className="number" scale={'caption500'}>
                            {number}
                        </Text>
                    )}
                    {icon && (
                        <Icon
                            className={'tag-icon'}
                            name={icon}
                            size={'16px'}
                            color={getTagFontColor('hover', contentType, theme) as IconColor}
                        />
                    )}
                    <Text className="label" scale={'caption500'} onMouseEnter={onTagHover}>
                        {label}
                    </Text>
                </StyledTextTag>
            </Tooltip>
        )
    },
)

TextTag.displayName = 'TextTag'

export default TextTag
